import { Link, useLocation, useNavigate } from "react-router-dom";
import { Dumbbell, FileQuestion, CalendarClock, CalendarPlus, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { id: "practice", label: "Practice sets", icon: Dumbbell, to: "/app/practice", paid: true },
  { id: "mock", label: "Mock exams", icon: FileQuestion, to: "/app/practice?mode=exam", paid: true },
  { id: "exams", label: "My exams", icon: CalendarClock, to: "/app/exams" },
];

function tabFor(pathname, search) {
  if (pathname.startsWith("/app/exams")) return "exams";
  return new URLSearchParams(search).get("mode") === "exam" ? "mock" : "practice";
}

// One Practice page: practice sets, mock exams and exam countdowns, with Add an exam always to hand.
export function PracticeTabs() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const { ent } = useAuth();
  const on = tabFor(pathname, search);
  return (
    <header className="space-y-5" data-testid="practice-hub-header">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div className="min-w-0">
          <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight" data-testid="practice-hub-title">Practice</h1>
          <p className="text-neutral-400 mt-2 text-sm sm:text-base">Practice sets, mock exams and your exam countdowns, all in one place.</p>
        </div>
        <button onClick={() => navigate("/app/exams?action=add")} data-testid="practice-add-exam-btn"
          className="h-10 px-5 rounded-full bg-sky-400 text-white text-sm font-medium hover:bg-sky-500 inline-flex items-center gap-2 transition-colors shrink-0">
          <CalendarPlus className="h-4 w-4" /> Add an exam
        </button>
      </div>
      <nav role="tablist" aria-label="Practice sections" className="flex gap-1 p-1 rounded-full border border-white/10 w-fit max-w-full overflow-x-auto scroll-thin" data-testid="practice-tabs">
        {TABS.map((t) => {
          const locked = t.paid && ent && !ent.features.practice;
          return (
            <Link key={t.id} to={t.to} role="tab" aria-selected={on === t.id} data-testid={`practice-tab-${t.id}`}
              className={`h-9 px-4 rounded-full text-sm inline-flex items-center gap-2 whitespace-nowrap outline-none focus-visible:ring-2 focus-visible:ring-sky-400/70 transition-colors ${
                on === t.id ? "bg-white/10 text-white" : "text-neutral-400 hover:text-white"}`}>
              <t.icon className="h-4 w-4" />{t.label}
              {locked && <Lock className="h-3 w-3 opacity-70" aria-label="Starter and above" data-testid={`practice-tab-${t.id}-lock`} />}
            </Link>
          );
        })}
      </nav>
    </header>
  );
}
